import { Record } from 'immutable';
import { loadPersistedState } from '../../utils/persist';
import { tokenFromSearch } from '../../utils/applicantToken';
import { ActionTypes } from './action-types';
import { IUpdatePlaidUserInfo, IUIState, ISetEnableDocUpload, ISetUserDetails } from './types';

type Actions = IUpdatePlaidUserInfo | ISetEnableDocUpload | ISetUserDetails;

// Only the snapshot saved for the link being opened; any other applicant's is dropped.
const persisted = loadPersistedState(tokenFromSearch(window.location.search))?.ui;

const record = Record<IUIState>({
  enableDocUpload: persisted?.enableDocUpload ?? false,
  userDetails: persisted?.userDetails ?? null,
  plaidUserInfo: persisted?.plaidUserInfo ?? {
    email: '',
    propertyName: '',
    unitNumber: '',
    fullName: '',
    phoneNumber: '',
    applicant_id: '',
    plaidUserId: '',
  },
});

class UIState extends record implements IUIState {}

export default function reducer(state = new UIState(), action: Actions) {
  switch (action.type) {
    case ActionTypes.UpdatePlaidUserInfo: {
      return state.set('plaidUserInfo', {
        ...state.plaidUserInfo,
        ...action.payload.userInfo,
      });
    }
    case ActionTypes.SetEnableDocUpload: {
      return state.set('enableDocUpload', action.payload.enableDocUpload);
    }
    case ActionTypes.SetUserDetails: {
      return state.set('userDetails', action.payload.userDetails);
    }
    default: {
      return state;
    }
  }
}
